/**
 * Marketing Preferences Storage
 * Minimal implementation to pass failing tests - No geo-data
 */

import { captureMessage, buildTags, toSerializable } from '@/lib/monitoring/logger';

interface MarketingPreferences {
  language: string;
  currency: string;
}

export function storeMarketingPreferences(preferences: MarketingPreferences): void {
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      localStorage.setItem('marketing_preferences', JSON.stringify(preferences));
    } catch (error) {
      captureMessage('marketing.preferences.store_failed', 'warning', {
        tags: buildTags('marketing-preferences', 'store'),
        extra: toSerializable({ error: error instanceof Error ? error.message : String(error), preferences })
      });
    }
  }
}

export function getMarketingPreferences(): MarketingPreferences | null {
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      const stored = localStorage.getItem('marketing_preferences');
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      captureMessage('marketing.preferences.retrieve_failed', 'warning', {
        tags: buildTags('marketing-preferences', 'retrieve'),
        extra: toSerializable({ error: error instanceof Error ? error.message : String(error) })
      });
      return null;
    }
  }
  return null;
}

export function storeCurrencyPreference(currency: string): void {
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      localStorage.setItem('preferred_currency', currency);
    } catch (error) {
      captureMessage('marketing.preferences.currency.store_failed', 'warning', {
        tags: buildTags('marketing-preferences', 'currency-store'),
        extra: toSerializable({ error: error instanceof Error ? error.message : String(error), currency })
      });
    }
  }
}

export function getCurrencyPreference(): string {
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      return localStorage.getItem('preferred_currency') || 'CHF';
    } catch (error) {
      captureMessage('marketing.preferences.currency.retrieve_failed', 'warning', {
        tags: buildTags('marketing-preferences', 'currency-retrieve'),
        extra: toSerializable({ error: error instanceof Error ? error.message : String(error) })
      });
      return 'CHF';
    }
  }
  return 'CHF'; // Default fallback
}
